import React from 'react';
import { Box, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import LegalPageLayout from '../../components/legal/LegalPageLayout';
import {
  COMPANY,
  LEGAL_LAST_UPDATED,
  PRICE_LIST_SENTENCE,
  SIGNUP_CLOSED_DATE,
  SUPPORT_EMAIL,
} from '../../constants/legal';

// 掲載内容は #38 で 2026-08-14 に確定した表をそのまま反映する。
// 電話番号の省略は「請求があれば遅滞なく提供する」旨の表示が条件のため、
// 開示体制（docs/manuals/legal-operations.md）とセットで維持すること。
const ROWS = [
  ['事業者名', COMPANY.name],
  ['所在地', COMPANY.address],
  ['代表者名', COMPANY.representative],
  ['電話番号', '請求により遅滞なく開示いたします。'],
  ['お問い合わせ先', `${SUPPORT_EMAIL}（受付手段はメールのみ）`],
  ['販売価格', PRICE_LIST_SENTENCE],
  ['商品代金以外の必要料金', 'なし。ただしインターネット接続に必要な通信費はお客様のご負担となります。'],
  ['支払方法', 'クレジットカード'],
  ['支払時期', 'お申込み時に初回のご請求を行い、以後は毎月同日に自動でご請求いたします。'],
  ['役務の提供時期', '決済完了後、ただちにご利用いただけます。'],
  ['契約期間・自動更新', '1ヶ月ごとの自動更新です。'],
  [
    '解約の方法・条件',
    'マイページからいつでも解約できます。解約後も当期（お支払い済みの期間）の末日までご利用いただけます。日割りでの返金は行いません。',
  ],
  ['返品・キャンセル', 'デジタル役務の提供のため、返金はいたしません。'],
  [
    '申込みの有効期限・数量制限',
    `有料プランの新規のお申込みは、${SIGNUP_CLOSED_DATE}をもって受付を終了しました。既存のご契約は、解約されるまで同一条件で継続します。`,
  ],
  [
    '有料プランの提供内容',
    '予想ページ（中央競馬・地方競馬・競輪）はどなたでも無料でご覧いただけます。有料プランをご契約中の方は、当社が本サービスに広告を掲載した場合も広告を表示せずにご利用いただけるほか、過去のモデルによる配信等の機能を引き続きご利用いただけます。',
  ],
  ['動作環境', '特に指定はありません。'],
];

function TokushohoPage() {
  return (
    <LegalPageLayout title="特定商取引法に基づく表記" lastUpdated={LEGAL_LAST_UPDATED}>
      <Box sx={{ overflowX: 'auto' }}>
        <Table
          size="small"
          sx={{
            '& td': {
              color: 'rgba(216, 236, 250, 0.86)',
              fontSize: 14,
              lineHeight: 1.9,
              borderColor: 'rgba(92, 160, 219, 0.14)',
              verticalAlign: 'top',
              py: 1.5,
            },
          }}
        >
          <TableBody>
            {ROWS.map(([label, value]) => (
              <TableRow key={label}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    width: { xs: 132, sm: 220 },
                    fontWeight: 700,
                    color: '#bfe6ff !important',
                  }}
                >
                  {label}
                </TableCell>
                <TableCell>{value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      <Typography sx={{ mt: 3, fontSize: 13, color: 'rgba(196, 224, 243, 0.62)', lineHeight: 1.9 }}>
        本サービスは競馬・競輪に関する参考情報を提供するものであり、的中や利益を保証するものではありません。
        投票はお客様ご自身の判断と責任で行ってください。
      </Typography>
    </LegalPageLayout>
  );
}

export default TokushohoPage;
